"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _immutable = require("immutable");
var _events = require("./events");
// Init state
// This is a message box's dictionary
// key is message box's id
// value is messages box's messages
var initialState = new _immutable.Map({});

// Init action handlers
var actionHandlers = {};

/**
 * Push a message to messages array of a message box
 * @param {Object} state
 * @param {Object} payload
 * @returns {Object} newState
 */
actionHandlers[_events.SHOW_MESSAGE] = function (state, _ref) {
  var payload = _ref.payload;
  var messages = state.get(payload.id);
  if (payload.message.clearOtherMessages) {
    return state.set(payload.id, Object.assign([], [payload.message]));
  }
  if (messages) {
    var dataId = payload.message.dataId;
    if (dataId) {
      messages = messages.filter(function (item) {
        return item.dataId && item.dataId !== dataId;
      });
    }
    messages.push(payload.message);
    return state.set(payload.id, Object.assign([], (0, _toConsumableArray2.default)(messages)));
  }
  return state.set(payload.id, Object.assign([], [payload.message]));
};

/**
 * Hide a message from message box
 * @param {Object} state
 * @param {Object} payload
 * @returns {Object} newState
 */
actionHandlers[_events.CLEAR_MESSAGE] = function (state, _ref2) {
  var payload = _ref2.payload;
  var messages = state.get(payload.id[0]);
  if (!messages) {
    return state;
  }
  messages = messages.filter(function (item) {
    return item.id !== payload.messageId;
  });
  return state.set(payload.id[0], Object.assign([], (0, _toConsumableArray2.default)(messages)));
};

/**
 * Remove messages array of a message box
 * @param {Object} state
 * @param {Object} payload
 * @returns {Object} newState
 */
actionHandlers[_events.CLEAR_MESSAGE_BOX] = function (state, action) {
  return state.delete(action.payload);
};

/**
 * Remove messages array of all message box
 * @returns {Object} newState
 */
actionHandlers[_events.CLEAR_ALL_MESSAGE_BOX] = function () {
  return initialState;
};
actionHandlers[_events.CLEAR_TOAST] = function (state, _ref3) {
  var payload = _ref3.payload;
  var messages = state.get(payload.id);
  if (messages) {
    messages = messages.filter(function (item) {
      return item.dataId && item.dataId !== payload.dataId;
    });
  }
  return state.set(payload.id, Object.assign([], (0, _toConsumableArray2.default)(messages)));
};

/**
 * Reducer handler
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object} next state
 */
var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  // Get appropriate action handler by type
  var fn = actionHandlers[action.type];
  // Check if handler is existed
  // Then call the handler
  // Otherwise return state
  return fn ? fn(state, action) : state;
};
exports.default = _default;